// extracted by mini-css-extract-plugin
export default {"section":"Categories_section__DBVXy","list":"Categories_list__zHWi5","item":"Categories_item__waQb5","image":"Categories_image__fR6dL","title":"Categories_title__yqZmH"};